import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_49: FaireProductEntity = {
  token: "legacy_prod_abbott-49",
  type: "product",
  name: "Nutcracker Pedestal Cake Plate (Clearance)",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/450d52c19910f7d029282e668ad72ce368acbce4ec1409b4559c66dd58f3cd31.jpeg",
  priceDollars: 22,
  msrpDollars: 44,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
